import { AbstractControl, ValidationErrors } from '@angular/forms';

export function offerNumberValidator(
  formControl: AbstractControl
): ValidationErrors | null {
  if (!formControl.value) {
    return null;
  }
  // check if the value is in correct format
  const regex = /^A?\d{6}$/;
  if (regex.test(formControl.value)) {
    return null;
  }
  return {
    'invalid-offer-number': true,
  };
}
